import React from "react";

const Button = ({ children, onClick, type, className, disabled }) => (
  <button
    type={type}
    onClick={onClick}
    className={`${className} ${disabled ? "opacity-75 cursor-not-allowed pointer-events-none" : ""}`}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
